import React, { useState } from "react";
import styles from '../Auth/input.module.css';
import '../posts/inputStyle.css';
import './../../css/table.css';
import axios from "axios";

const AppNotification = () => {

    const [title, setTitle] = useState();
    const [body, setBody] = useState();


    const SendNotification = (e) =>
    {
        e.preventDefault();
        const config = {
            headers: {
                'Authorization' : 'key=AAAAcM88r-4:APA91bEMxF80RjuzOqjmmhUxKStN5BMckanyImMuAxmfy4PK4Bp1BPiLU3lYeN7AR5UWOamg2aqtqpXCTawnJoEaX8LOZLLinCIlmXRKr-iQpYXamfOl28uqIgCpAz-jd_s9GK2rrH30',
                'Content-Type': 'application/json'
            }
        }
        axios.post('https://fcm.googleapis.com/fcm/send',{
            data:{
                title,
                body, 
            },
            to: "/topics/all"
        }, config).then(res =>{
            console.log('res', res);
        }).catch(err =>{
            console.log(err)
        })
    };
  return (
    <div className="index">
      <form onSubmit={SendNotification}>
        <h2>ارسال پوش نوتیفیکیشن به اپ اندروید</h2>
        <div className={styles.inputWrap}>
          <label className={styles.label}>
            عنوان...
          </label>
          <input
            name='title'
            type='text'
            className={styles.input}
            placeholder={'عنوان نوتیفیکیشن'}
            onChange={(e)=> setTitle(e.target.value)}
          />
        </div>

        <div className={styles.inputWrap}>
          <label className={styles.label}>
            متن...
          </label>
          <textarea
            name='body'
            type='text'
            className={styles.input}
            placeholder={'متن نوتیفیکیشن'}
            onChange={(e)=> setBody(e.target.value)}
          />
        </div>

        <div className="inputBox">
          <button
            type="submit"
            className='btn-success'
            
          >
            ارسال
          </button>
        </div>
      </form>
    </div>
  );
};

export default AppNotification;
